import NotFoundPage from './NotFoundPage'

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/legacy/pages/NotFoundPage/index.js